import { render, staticRenderFns } from "./StatEditor.vue?vue&type=template&id=db3a483c&scoped=true"
import script from "./StatEditor.vue?vue&type=script&lang=js"
export * from "./StatEditor.vue?vue&type=script&lang=js"
import style0 from "./StatEditor.vue?vue&type=style&index=0&id=db3a483c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3a483c",
  null
  
)

export default component.exports